import { apiGet, apiPatch, demoMode } from './api';
import { readSalonSettings, writeSalonSettings, type SalonSettings } from './salonSettings';

// Настройки салона: контакты, график, услуги, мастера, галерея.
// Демо: localStorage. Прод: tenants.business в D1 — владелец правит
// один раз, все устройства и клиенты видят одно и то же.
// Здесь единая точка чтения/записи, чтобы витрина и кабинет не разъезжались.

type OwnerSettingsResponse = {
  tenant: {
    name?: string;
    city?: string;
    phone?: string;
    address?: string;
    timezone?: string;
    theme?: Record<string, unknown>;
    business?: Partial<SalonSettings>;
  };
  services?: Array<Record<string, unknown>>;
  staff?: Array<Record<string, unknown>>;
  resources?: Array<Record<string, unknown>>;
};

export async function fetchTenantBusiness(_tenantId: string): Promise<SalonSettings> {
  if (demoMode) return readSalonSettings();

  const data = await apiGet<OwnerSettingsResponse>('/owner/settings');
  const base = readSalonSettings();
  const stored = (data.tenant?.business ?? {}) as Partial<SalonSettings>;
  return {
    ...base,
    ...stored,
    services: data.services?.map((item) => ({
      id: String(item.id), name: String(item.name), price: Number(item.price),
      durationMinutes: Number(item.durationMin), description: String(item.description ?? ''), popular: Boolean(item.popular)
    })) ?? stored.services ?? base.services,
    staff: data.staff?.map((item) => ({ id: String(item.id), name: String(item.name), role: String(item.role ?? '') })) ?? stored.staff ?? base.staff
  };
}

export async function saveTenantBusiness(
  _tenantId: string,
  next: SalonSettings
): Promise<void> {
  if (demoMode) {
    writeSalonSettings(next);
    return;
  }

  // PATCH /api/owner/settings сам знает, чей это салон — по cookie сессии.
  await apiPatch<{ ok: boolean }>('/owner/settings', {
    business: next,
    services: next.services.map((item) => ({ ...item, code: item.id, durationMin: item.durationMinutes, active: true })),
    staff: next.staff.map((item) => ({ ...item, code: item.id, active: true }))
  });
}
